<template>
    <v-container fluid>
        <v-skeleton-loader
                v-if="!visible"
                ref="inscritos"
                type="table"
                class="mx-auto"
        ></v-skeleton-loader>

        <v-card v-else>
            <v-card-title>
                Listado de inscritos
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="getHeaders"
                    :items="inscritos"
                    :search="search"
                    locale='es'
                    ref="inscritos"
            ></v-data-table>
            <v-row>
                <v-col class="col" xs="12" sm="6" md="4" offset-md="8" >
                    <v-btn href="http://reservasprames.com/roscon10k/rectificacion.php"
                           target="_blank"
                           large color="info">Quiero cambiar mis datos</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
    import {insService} from "@/_services";

    export default {
        name: "ListaInscritos",
        props: ['carrera'],
        data() {
            return {
                search:'',
                headers: {
                    roscon: [
                        { text: 'Dorsal', value: 'dorsal' },
                        { text: 'Nombre', value: 'nombre' },
                        { text: 'Apellidos', value: 'apellidos' },
                        { text: 'Equipo', value: 'equipo' },
                        { text: 'Club', value: 'club' },
                        { text: 'Categoría', value: 'categoria' },
                        { text: 'Federado', value: 'federado', sortable: false },
                        { text: 'Talla', value: 'talla', sortable: false }
                    ],
                    infantil:[
                        { text: 'Dorsal', value: 'dorsal' },
                        { text: 'Nombre', value: 'nombre' },
                        { text: 'Apellidos', value: 'apellidos' },
                        { text: 'Club', value: 'club' },
                        { text: 'Categoría', value: 'categoria' },
                        { text: 'Federado', value: 'federado', sortable: false },
                        { text: 'Talla', value: 'talla', sortable: false },
                    ]
                },
                corredores: [],
                visible: false
            }
        },
        created() {
            insService.getInscritosByRace(this.carrera || 1).then( lista => {
                this.corredores = lista
                this.visible = true
            })
        },
        computed: {
            getHeaders() {
                if (this.carrera == 1 || this.carrera == 2 || !this.carrera)
                    return this.headers.roscon
                else
                    return this.headers.infantil
            },
            inscritos() {
                return this.corredores
            }
        }
    }
</script>

<style scoped>

</style>